import { DateTime, DateTimeUnit } from 'luxon';

export const isDateOverdue = (
  date: number,
  pastDue: DateTimeUnit,
  duration = 1,
) => {
  const zone = 'Europe/London';
  const now = DateTime.now().setZone(zone);
  return (
    now
      .diff(
        DateTime.fromMillis(date ?? 0)
          .setZone(zone)
          .startOf(pastDue),
        pastDue,
      )
      .get(pastDue) >= duration
  );
};
